import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from './contexts/AuthContext';
import ErrorBoundary from './ErrorBoundary';
import { ThemeProvider } from './components/ui/theme-provider';
import AuthenticatedApp from './pages/AuthenticatedApp';
import UnauthenticatedApp from './pages/UnauthenticatedApp';

function App() {
  const { isAuthenticated, initializeAuth } = useAuth();
  const [isInitialized, setIsInitialized] = useState(false);
  const initializationRef = useRef(false);

  // Initialize auth state on mount
  useEffect(() => {
    // Prevent multiple initializations
    if (initializationRef.current) return;
    
    const init = async () => {
      initializationRef.current = true;
      console.log('App: Initializing auth state...');
      await initializeAuth();
      setIsInitialized(true);
    };
    
    init();
  }, [initializeAuth]);

  // Show loading state while checking auth
  if (!isInitialized) {
    return <div>Loading...</div>;
  }

  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        {isAuthenticated ? <AuthenticatedApp /> : <UnauthenticatedApp />}
      </ThemeProvider>
    </ErrorBoundary>
  );
}

// Use React.memo to prevent unnecessary re-renders
export default React.memo(App);
